module.exports = __webpack_public_path__ + "img/fangan5.2816fa88.png";